<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    titleKey="last_version.name"
    editType="updateVersion"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/license_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "training_hours",
                "locales",
                "statitory_extension_period",
                "recommend_notify_period",
                "acts",
              ],
            },
          ],
        },
      ],
    },
  }),
};
</script>